<template>
    <div 
      :class="['reportCard', isActive]" 
      @click="(e) => $emit('click', e)"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ title }}</div>
      <div class="cardDesc"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportCard',
    props: {
        isActive: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped lang="scss">
.reportCard.active {
  background-color: var(--v-primary-base);
  color: var(--v-lighten-base);
  cursor: auto;
}

.reportCard {
  border: 1px var(--v-primary-darken2) solid;
  padding: 5px 0;
  cursor: pointer;
  text-align: left;
}

.reportCard .cardImg {
  float: left;
  font-size: 45px;
  width: 50px;
  height: 50px;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard > div > i {
  vertical-align: top;
}

.reportCard .cardDesc {
  width: 80%;
}

.fal {
  font-family: "Font Awesome 5 Pro";
  font-weight: 300;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
</style>